import React from 'react';
import { useTranslation } from 'react-i18next';
import Aux from '../../hoc/Aux';

const ProjectSolutionCalculationResult = (props) => {

  const { t } = useTranslation();

    if (props.calculator === undefined) {
      return null
    } else {

    const statusMessage = () => {
      return t('product_solution.calculation_result.' + props.resSchottbelegung.status )
    }

    const statusColor = () => {
      switch (props.resSchottbelegung.status) {
        case 'greater_than_max':
          return "danger"
        case 'between_max_and_krit':
          return "warning"
        case 'lower_than_krit':
          return "success"
        default:
          return "info"
      }
    }

    const errorMessage = () => {
      return <span>{props.resSchottbelegung.errors.reduce((prev, curr) => [prev, ' ', curr]) }</span>;
    }

    const area_unit = "mm²";

    const numberWithCommas = (x) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    const displayArea = (x) => numberWithCommas(x).toString() + " " + area_unit.toString()

    const errors = () => {
      return !( props.resSchottbelegung.errors === undefined || (Array.isArray(props.resSchottbelegung.errors) && props.resSchottbelegung.errors.length === 0) || props.resSchottbelegung.errors === null)
    }

    return (

      <div className="container">
        <div className="row">
          <div className="col-12 col-xl-8">
            <table width="100%">
            <tbody>


          { (props.calculator.hole_form === "square") && (
            <Aux>
              <tr>
                <td>{ t('product_solution.calculation_result.langtext.form_des_durchbruchs_label.long') }</td>
                <td colSpan={3} style={{textAlign: "right"}}>{ t('product_solution.calculation_result.langtext.form_des_durchbruchs_eckig') }</td>
              </tr>
              <tr>
                <td>{ t('product_solution.calculation_result.langtext.flaeche_des_durchbruchs.long', { height: props.calculator.hole_height,
                                                                                               width: props.calculator.hole_width} )}</td>
                <td></td>
                <td style={{padding: "0px 10px"}}> = </td>
                <td style={{textAlign: "right", whiteSpace: "nowrap", maxWidth: "120px"}}>{ displayArea(props.resSchottbelegung.possible_area) }</td>
              </tr>
            </Aux>
          )}


          { (props.calculator.hole_form === "circle") && (
            <Aux>
              <tr>
                <td>{ t('product_solution.calculation_result.langtext.form_des_durchbruchs_label.long') }</td>
                <td colSpan={3} style={{textAlign: "right"}}>{ t('product_solution.calculation_result.langtext.form_des_durchbruchs_rund') }</td>
              </tr>
              <tr>
                <td>{ t('product_solution.calculation_result.langtext.flaeche_des_durchbruchs_rund.long', { diameter: props.calculator.hole_diameter} )}</td>
                <td></td>
                <td style={{padding: "0px 10px"}}> = </td>
                <td style={{textAlign: "right", whiteSpace: "nowrap", maxWidth: "120px"}}>{ displayArea(props.resSchottbelegung.possible_area) }</td>
              </tr>
            </Aux>

          )}

          { !errors() && ( props.calculator.hole_form === "circle" || props.calculator.hole_form === "square") && (
            <Aux>
              <tr>
                <td>{ t('product_solution.calculation_result.langtext.belegbare_flaeche.long') }</td>
                <td style={{textAlign: "right", whiteSpace: "nowrap"}}>{ props.resSchottbelegung.max_area_allocation_in_percent } %</td>
                <td style={{padding: "0px 10px"}}> = </td>
                <td style={{textAlign: "right", whiteSpace: "nowrap", maxWidth: "120px"}}>{ displayArea(props.resSchottbelegung.max_area_allocation_in_area) }</td>
              </tr>

              <tr>
                <td>{ t('product_solution.calculation_result.langtext.aktuell_belegte_flaeche.long') }</td>
                <td style={{textAlign: "right", whiteSpace: "nowrap"}}>{ props.resSchottbelegung.sum_in_percent } %</td>
                <td style={{padding: "0px 10px"}}> = </td>
                <td style={{textAlign: "right", whiteSpace: "nowrap", maxWidth: "120px"}}>{ displayArea(props.resSchottbelegung.sum_in_area) }</td>
              </tr>

              <tr>
                <td>{ t('product_solution.calculation_result.langtext.reserve_fuer_nachbelegung.long') }</td>
                <td style={{textAlign: "right", whiteSpace: "nowrap"}}>{ props.resSchottbelegung.reserve_in_percent } %</td>
                <td style={{padding: "0px 10px"}}> = </td>
                <td style={{textAlign: "right", whiteSpace: "nowrap", maxWidth: "120px"}}>{ displayArea(props.resSchottbelegung.reserve_in_area) }</td>
              </tr>

              <tr>
                <td style={{padding: "20px 0px"}}><button className="btn btn-primary" onClick={()=> props.showCalculatorForm()}>{ t('product_solution.calculation_result.langtext.button_schottgroesse_aendern') }</button></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>

            </Aux>

          )}

          { errors() && (
            <div>
              <br />
              <button className="btn btn-primary" onClick={()=> props.showCalculatorForm()}>{ t('product_solution.calculation_result.langtext.button_schottgroesse_aendern') }</button>
            </div>
          )}
          </tbody>
          </table>

          { (false) && (
            <div>
            <hr />
             Summe (area): { props.resSchottbelegung.sum_in_area }<br />
             Summe (%): { props.resSchottbelegung.sum_in_percent}<br />
             Reserve (area): { props.resSchottbelegung.reserve_in_area }<br />
             Reserve (%): { props.resSchottbelegung.reserve_in_percent}<br />
             krit_area_allocation (area): { props.resSchottbelegung.krit_area_allocation_in_area }<br />
             max_area_allocation (area): { props.resSchottbelegung.max_area_allocation_in_area }<br />
             krit_area_allocation (%): { props.resSchottbelegung.krit_area_allocation_in_percent }<br />
             max_area_allocation (%): { props.resSchottbelegung.max_area_allocation_in_percent }<br />
             status: { props.resSchottbelegung.status }<br />
             errors: { props.resSchottbelegung.errors }<br />
             formfaktor: { props.calculator.hole_form }<br />
            </div>
          )}

          </div>
          <div className="col-12 col-xl-4">

          { !errors() && (
            <div className={"alert alert-" + statusColor() + " mb-3"}>
              <p>{ statusMessage() }</p>
            </div>
          )}

          { errors() && (
            <div className={"alert alert-danger mb-3"}>
                <p>{ errorMessage() }</p>
            </div>
          )}



          </div>
        </div>
      </div>

    )
  }
}



export default ProjectSolutionCalculationResult



// WEBPACK FOOTER //
// ./src/components/Modals/ProjectSolutionCalculationResult.js